import { render, staticRenderFns } from "./ParkingSpaceConfig.vue?vue&type=template&id=f03fa666&scoped=true&"
import script from "./ParkingSpaceConfig.vue?vue&type=script&lang=js&"
export * from "./ParkingSpaceConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03fa666",
  null
  
)

export default component.exports